
<script setup lang="ts">
const excerpt = undefined
  defineExpose({ frontmatter: {}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><h1>用户协议</h1>
<h2>饼次元用户服务协议</h2>
<p>导言：
欢迎您使用饼次元软件及服务！
为使用&quot;饼次元&quot;平台提供的饼次元软件及服务（以下简称&quot;本软件&quot;、“饼次元&quot;或&quot;本服务”），您应当阅读并遵守《饼次元用户服务协议》（以下简称&quot;本协议&quot;）以及饼次元服务的各项制度规范等。
请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款已以加粗形式提示您注意。
除非您已阅读并接受本协议所有条款，否则您无权使用本软件及相关服务。您的下载、安装、使用、获取账号、登录等行为（以下统称为&quot;使用&quot;）即视为您已阅读并同意上述协议的约束。
您有违反本协议的任何行为时，本平台有权依照违反情况，随时单方限制、中止或终止向您提供本服务，并有权追究您的相关责任。
如果您未满18周岁，请在监护人的陪同下阅读本协议及其他上述协议，并特别注意未成年人使用条款。<br>
一、特别提示
本平台同意按照本协议的规定及其不时发布的操作规则提供基于互联网的相关服务(以下称&quot;网络服务&quot;)。为获得本服务，用户同意本协议的全部条款并**通过运营商正规渠道获取的手机号码进行账号注册。注册过程中需进行短信验证并绑定一个有效的手机号码，点击&quot;登录&quot;按钮即表示用户已经详细阅读了本协议的内容，同意遵守本协议的约定。**用户不应再以不了解本协议内容为由拒绝履行本协议。**本平台有权对本协议随时进行修改与更新，并在相关官方网站公告新协议内容。**修改后的服务协议一旦在页面上公布即有效代替原来的服务协议。请用户随时造访本软件内&quot;账号登录&quot;界面以及&quot;关于我们&quot;页面查看本协议的最新版本。用户在使用本平台提供的各项服务之前，应仔细阅读本服务协议，如用户不同意本服务协议及/或随时对其的修改，用户可以主动取消本平台提供的网络服务。<br>
二、定义
1.饼次元软件：是向用户提供的使用工具，在本协议中简称&quot;饼次元&quot;。
2.用户：是指启用、浏览或上传数据至饼次元服务的用户，在本协议中更多地称为&quot;您&quot;。
3.其他用户：是指除用户本人外与饼次元服务相关的其他饼次元用户。
三、协议的范围
1.本协议是您与本平台之间关于用户下载、安装、使用本软件，以及使用饼次元相关服务所订立的协议。
2.本协议内容同时包括本平台可能不断发布的关于本服务的相关协议、服务声明、业务规则及公告指引等内容（包括但不限于《饼次元用户个人信息保护及隐私政策协议》等）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。
四、关于本软件
1.服务许可
1.1本软件可能提供多个应用版本，用户必须选择与所安装设备相匹配的软件版本。用户可根据本协议获得以下许可：
1.1.1本平台给予您一项个人的、不可转让及非排他性的许可，以使用本软件。您可以为非商业目的在单一台终端设备上安装、使用、显示、运行本软件。<br>
1.1.2本条及本协议其他条款未明示授权的其他一切权利仍由本平台保留，您在行使这些权利时须另外取得本平台的书面许可。本平台如果未行使前述任何权利，并不构成对该权利的放弃。
2.安装与卸载
2.1您可以直接从饼次元官网获取本软件，也可以从得到本平台授权的第三方获取。如果您从未经本平台授权的第三方获取本软件或与本软件名称相同的安装程序，本平台无法保证本软件能够正常使用，并对因此给您造成的损失不予负责。
2.2本平台可能为不同的终端设备开发了不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。下载安装程序后，您需要按照该程序提示的步骤正确安装。为提供更加优质、安全的服务，在本软件安装时本平台可能推荐您安装其他软件，您可以选择安装或不安装。
2.3如果您不再需要使用本软件或者需要安装新版软件，可以自行卸载。如果您愿意帮助饼次元改进产品服务，请告知卸载的原因。<br>
2.4为了改善用户体验、完善服务内容，本平台将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。为了保证本软件安全性和功能的一致性，本平台有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。本软件新版本发布后，旧版本的软件可能无法使用。本平台不保证旧版本软件继续可用及相应的客户服务，请您随时核对并下载最新版本。
五、用户个人信息保护及隐私政策
1.本平台将按照本协议及《饼次元用户个人信息保护及隐私政策协议》的规定收集、储存和使用用户的个人信息。本协议对个人信息保护规定的内容与上述《饼次元用户个人信息保护及隐私政策协议》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《饼次元用户个人信息保护及隐私政策协议》的内容为准。<br>
2.用户在注册账号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，用户需要填写真实、完整、有效的身份信息，依据相关法律规定和本协议约定对所提供的信息承担相应的法律责任。若用户填写的信息不完整或提供的资料已变更未更新，则无法使用本服务或在使用过程中受到限制，本平台不因此承担任何责任。
3.本平台保证不对外公开或向第三方（除本协议另有约定外）提供用户注册资料及用户在使用网络服务时存储在本平台的非公开内容，但下列情况除外：
3.1事先获得用户的明确授权；
3.2根据有关的法律法规要求；
3.3按照相关政府主管部门的要求；
3.4为维护社会公众的利益；
3.5为维护本平台的合法权益。
4.在不透露单个用户隐私资料的前提下，本平台有权对整个用户数据库进行技术分析，并将分析后的数据用于改善产品的用户体验，为产品的商业决策提供服务支撑，改进并优化我们的产品和服务。
5.本平台将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。您能理解，本平台对用户的隐私权保护做了极大的努力，但是仍然不能保证现有的安全技术措施使用户的技术信息等不受任何形式的损失。
6.本平台非常重视对未成年人个人信息的保护。若用户是18周岁以下的未成年人，在使用本平台的服务前，应事先取得家长或法定监护人（以下简称&quot;监护人&quot;）的书面同意；若父母（监护人）希望未成年人（尤其是十岁以下子女）得以使用服务的，须以父母（监护人）名义申请注册，在接受网络服务时，应以父母（监护人）身份加以判断本服务是否符合于未成年人。
六、用户注意事项
1.您理解并同意，如您在使用本服务时未使用相关账户登录，由此引发的任何问题，本平台概不负责。
2.您理解并同意，为了向您提供有效的服务，本软件会利用您设备终端的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。<br>
3.您在使用本软件某一特定服务时，该服务可能会另有单独的协议、专项规则等，您在使用该项服务前请阅读并同意相关的单独协议、专项规则。
4.您理解并同意本平台将会尽其商业上的合理努力保障您在本软件中的数据存储安全，但是，本平台并不能就此提供完全保证，包括但不限于以下情形：
4.1本平台不对您在本软件中相关数据的删除或储存失败负责；
4.2如果您停止使用本软件超过一年或服务被终止或取消的，包括但不限于注销帐号、帐号违规永久封禁等情况，本平台有权可以从服务器上永久地删除您的数据，也没有义务向您返还任何数据。
4.3用户在使用本软件时，须自行承担如下本平台不可掌控的风险内容，包括但不限于：
4.3.1由于信息网络设备维护、连接故障，系统故障，电力故障，罢工，暴乱，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或因第三方因素可能引起的个人信息丢失、泄漏及其他损害等风险；<br>
4.3.2如使用本客户端软件，用户必须选择与所安装设备相匹配的软件版本，否则，由于软件与设备型号不相匹配所导致的任何问题或损害，均由用户自行承担；
4.3.3用户发布的内容或您的软件使用信息被他人转发、分享，因此等传播可能带来的风险和责任；
4.3.4由于网络信号不稳定、网络带宽小等原因，所引起的本软件登录失败、资料同步不完整、页面打开速度慢等风险。
5.服务变更、中断或终止
5.1用户接受、使用或在相关更新条款发布后继续使用本软件的行为，视为接受并认可相关条款的法律效力及对双方的约束力，且用户认可相关条款（包括但不限于任何更新后的条款）具有溯及至该用户账号首次登陆本软件之日的法律效力并在该日起对双方有共同的约束力。
5.2用户在接受本服务时实施不正当行为的，本平台有权终止对用户提供服务，该不当行为包括但不限于违约、违法、违反公序良俗、侵犯本平台或任何第三方之权益等。<br>
5.3用户在接受本服务时实施本协议中有明确约定或属于本平台事先明确告知的应被终止服务的禁止性行为的，本平台有权终止对用户提供服务。
5.4用户利用本软件进行洗钱、预付卡套现、购买等违法行为的，本平台有权在不事先通知用户的情况下中止或终止部分或全部网络服务的权利。
5.5如用户传播本软件作品章节相关内容的图档、文字，或有其他违反有关法律、法规或本协议项下的任何条款，而给本平台或任何其他第三人造成损失；或者因用户自身过错导致本人账号或密码泄露，而给本平台或任何其他第三人造成损失的，本平台将终止向用户提供本协议项下的网络服务，无需通知用户，并不退回相关账号剩余金额。
5.6如因系统维护或升级的需要而需暂停服务，本平台将尽可能事先进行通告。
5.7如因突发性网络设备故障、网络设备因不明原因停止、不可抗力、相关政府机构要求及其他情况，发生未能事先通知用户的服务部分或全部中断或终止，造成的任何损失，本平台无需对用户或任何第三方承担责任。<br>
6.广告
6.1您同意本平台可以在提供服务的过程中自行或由第三方广告商通过电子邮件或其他方式向您发送广告、推广或宣传信息（包括商业与非商业信息）。
6.2您同意，本平台在提供服务的过程中以各种形式投放商业性广告或其他任何类型的商业性信息，是本平台为所有用户提供综合（免费）服务的有效对价，您接收本平台服务即视为对该规则的理解和接受。
6.3本平台依照法律的规定履行相关义务，您应当自行判断广告信息的真实性并为自己的判断行为负责，除法律明确规定外，您因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，本平台不承担责任。
6.4您同意，对本软件中出现的广告信息，您应审慎判断其真实性和可靠性，除法律明确规定外，您应对依该广告信息进行的交易负责。
6.5您理解并同意，非正当屏蔽本平台所提供的广告将给本平台造成极大的损失，因此您不会主动采取非正当手段屏蔽广告内容。<br>
7.关于单项服务的特殊约定
7.1本软件及相关服务中包含公司以各种合法方式获取的信息或信息内容链接，同时也包括公司及其关联方合法运营的其他单项服务。
7.2您可以在本软件中开启和使用单项服务。某些单项服务可能需要您同时接受就该单项服务特别指定的协议或者其他约束您与该单项服务提供者之间的规则。公司将在您计划使用前述单项服务时以醒目的方式向您提供这些协议、规则，供您查阅与同意。一旦您开始使用上述服务，则视为您就理解并接受有关单项服务的相关协议、规则的约束。
7.3在用户使用平台服务的同时，本平台将会附赠金币奖励、现金奖励等除阅读之外的服务，但该等服务均为随号赠送福利。如本平台根据自身技术排查，发现任何滥用金币奖励、现金奖励等福利的任何作弊的行为，或对数据产生重大质疑，均可以判定用户本次参加活动的行为无效，取消该账户所有福利，甚至封禁该账户。<br>
8.第三方产品和服务
8.1您在使用本软件第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。本平台和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。
8.2因用户使用本软件或要求本平台提供特定服务时，本软件可能会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供，本平台不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与本平台无关，本平台不承担任何责任。
9.拒绝提供担保
9.1用户个人对网络服务的使用承担风险。本平台对以下事宜不作任何类型的担保，不论是明确的或隐含的：
9.1.1本协议项下本平台提供的相关网络服务将符合用户的要求；
9.1.2本协议项下本平台提供的相关服务将不受不可抗力、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机、电信部门原因及其他任何网络、技术、通信线路等外界或人为因素的影响；<br>
9.1.3通过本软件的链接和标签所指向的第三方的商业信誉及其提供服务的质量。
七、用户行为规范
1.信息内容规范
1.1本条所述信息内容是指用户使用本服务过程中所制作、复制、发布、传播的任何内容，包括但不限于饼次元登录账号头像、名字、用户说明等注册信息，以及其他使用饼次元登录账号或本软件及服务所产生的内容。
1.2您理解并同意，本平台一直致力于为用户提供文明健康、规范有序的网络环境，您不得利用本软件制作、复制、发布、传播如下干扰本服务正常运营，以及侵犯其他用户或第三方合法权益的内容，包括但不限于：
1.2.1发布、传送、传播、储存违反国家法律法规禁止的内容：
（1）违反宪法确定的基本原则的；
（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
（3）损害国家荣誉和利益的；
（4）煽动民族仇恨、民族歧视，破坏民族团结的；<br>
（5）破坏国家宗教政策，宣扬邪教和封建迷信的；
（6）散布谣言，扰乱社会秩序，破坏社会稳定的；
（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
（8）侮辱或者诽谤他人，侵害他人合法权益的；
（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；
（10）以非法民间组织名义活动的；
（11）含有法律、行政法规禁止的其他内容的。
1.2.2发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；
1.2.3未经他人许可发布、传送、传播涉及他人隐私、个人信息或资料的内容；
1.2.4发表、传送、传播骚扰、广告信息及垃圾信息或含有任何性或性暗示的；
1.2.5其他违反法律法规、政策及公序良俗、社会公德或干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。
2.软件使用规范
2.1除非法律允许或本平台书面许可，您使用本软件过程中不得从事下列行为：<br>
（1）删除本软件及其副本上关于著作权的信息；
（2）对本平台拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；
（3）修改或遮盖网络服务或相关产品程序、图像、动画、包装和手册等内容上的产品名称、公司标志、版权信息等内容；
（4）公开展示和播放本产品的全部或部分内容；
（5）对网络服务或相关产品的程序、图像、动画和音乐进行还原、反编译、反汇编、剪辑、翻译和改编等任何修改行为；
（6）对网络服务或相关产品进行反向工程（Reverse Engineering）、反向编译（Decompile）或反汇编（Disassemble）等任何技术性的与合理使用网络服务无关的行为或者以其他方式尝试发现本软件的源代码；
（7）对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非本平台经授权的第三方工具/服务接入本软件和相关系统；<br>
（8）通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
（9）通过非本平台开发、授权的第三方软件、插件、外挂、系统，登录或使用本平台软件及服务，或制作、发布、传播上述工具；
（10）以本网络服务作为营业使用；
（11）自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰；
（12）其他未经本平台明示授权或违反著作权法、计算机软件保护条例和相关法规的行为。
3.运营规范
3.1您使用本服务过程中不得从事下列行为：
（1）提交、发布虚假信息，或冒充、利用他人名义的；
（2）诱导其他用户点击链接页面或分享信息的；
（3）虚构事实、隐瞒真相以误导、欺骗他人的；
（4）侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；<br>
（5）未经本平台书面许可利用账号和任何服务，以及第三方运营平台进行推广或互相推广的；
（6）利用本软件及服务从事任何违法犯罪活动的；
（7）制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；
（8）其他违反法律法规规定、侵犯其他用户合法权益、干扰产品正常运营或本平台未明示授权的行为。
对自己行为负责
4.1您充分了解并同意，您必须为自己账号在本软件下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对本软件中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险；同时，您应在本协议约定的范围内使用本服务，因您利用本软件进行违反法律法规、本协议、专项规则的行为所产生的风险亦由您自行承担。本平台无法且不会对因前述风险而导致的任何损失或损害承担责任。<br>
八、管理规范
1.本平台有权根据国家相关法规政策，按照本协议的规定，对您发布、传送、传播、储存的内容进行审查，以保证用户使用本服务的行为不违反法律法规及社会公共道德准则、不侵犯本平台或第三方的合法权益、不带有诋毁本平台及饼次元产品形象的要素。但并不因为本平台的审核而减轻您自身使用本服务时应承担的责任，由此产生的一切责任和后果仍由您自行承担。
2.如果本平台发现或收到他人举报或投诉用户违反本协议约定或损害本平台权益的，本平台有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规账号处以包括但不限于警告、限制或禁止使用部分或全部服务、账号封禁等的处罚，并公告处理结果。
3.您理解并同意，本平台有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此而产生的一切法律责任。<br>
4.您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；本平台因此遭受损失的，您也应当一并赔偿。
5.除非平台与用户有书面约定或以合法方式获得有效授权，本平台不会主动使用用户通过平台上传的原创作品用于生成式绘画AI的模型训练。
九、知识产权声明
1.本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，本平台享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。
2.未经本平台或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权，您不得对任何该信息、资料、文字、软件、声音、图片、视频、图表进行修改、拷贝、散布、传送、展示、执行、复制、发行、授权、制作衍生著作、移转或销售。如您未遵守本条款的上述规定，将视为您的严重违约，在不损害其他权利的情况下，本平台可立即终止向您提供服务，解除双方间的服务协议和法律关系，且无需退还您在饼次元平台账户金额，该金额视为您支付本平台的违约金，如违约金不足以弥补本平台的损失的，本平台还可通过其他法律途径向您追索。同时您必须销毁任何已经获得的上述信息、资料、文字、软件、声音、图片、视频、图表。<br>
十、遵守当地法律监管
1.您在使用本服务过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。如果您的行为违反了当地法律法规或道德风俗，您应当为此独立承担责任。
2.您应避免因使用本服务而使本平台卷入政治和公共事件，否则本平台有权暂停或终止对您的服务。
3.违反本条约定，视为您的严重违约，本平台可以中止对您的服务，解除双方间的服务协议和法律关系，且无需退还您饼次元平台账户金额，该金额视为您支付本平台的违约金，如违约金不足以弥补本平台的损失的，本平台还可通过其他法律途径向您追索。
十一、终端安全责任
1.您理解并同意，本软件同大多数互联网软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。<br>
2.您不得制作、发布、使用、传播用于窃取饼次元登录账号及他人个人信息、财产的恶意程序。
3.维护软件安全与正常使用是本平台和您的共同责任，本平台将按照行业标准合理审慎地采取必要技术措施保护您的终端设备信息和数据安全，但是您承认和同意本平台并不能就此提供完全保证。
4.在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意饼次元有关防范诈骗犯罪的提示。
5.本软件设有网络信息安全投诉、举报制度，您可通过意见反馈界面或联系在线客服的方式进行网络信息安全的投诉与举报，本平台会及时受理并处理相关投诉和举报。
十二、通知和送达
本协议项下所有的通知均可通过重要页面公告、电子邮件、短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。<br>
十三、其他
1.本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。
2.本协议签订地为中华人民共和国大陆境内。
3.本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括《法律适用法》）。
4.若您和本平台之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
5.本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
6.本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。<br>
（正文完）</p>
</div>
</template>
